module.exports = __webpack_public_path__ + "images/help/video-newtodo@2x-e447bcb630a30bb495c5759a5cb16cba.png";